/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PropertyFromJsonSchema } from './PropertyFromJsonSchema';
import {
	PropertyFromJsonSchemaFromJSON,
	PropertyFromJsonSchemaFromJSONTyped,
	PropertyFromJsonSchemaToJSON,
} from './PropertyFromJsonSchema';
import type { PropertyFromUISchema } from './PropertyFromUISchema';
import {
	PropertyFromUISchemaFromJSON,
	PropertyFromUISchemaFromJSONTyped,
	PropertyFromUISchemaToJSON,
} from './PropertyFromUISchema';

/**
 * A payload to update single property in a metadata schema. Only updating title and adding of enum values is allowed.
 * @export
 * @interface UpdateMetadataSchemaProperty
 */
export interface UpdateMetadataSchemaProperty {
	/**
	 *
	 * @type {PropertyFromJsonSchema}
	 * @memberof UpdateMetadataSchemaProperty
	 */
	propertyFromJsonSchema?: PropertyFromJsonSchema;
	/**
	 *
	 * @type {PropertyFromUISchema}
	 * @memberof UpdateMetadataSchemaProperty
	 */
	propertyFromUISchema?: PropertyFromUISchema;
}

/**
 * Check if a given object implements the UpdateMetadataSchemaProperty interface.
 */
export function instanceOfUpdateMetadataSchemaProperty(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function UpdateMetadataSchemaPropertyFromJSON(
	json: any
): UpdateMetadataSchemaProperty {
	return UpdateMetadataSchemaPropertyFromJSONTyped(json, false);
}

export function UpdateMetadataSchemaPropertyFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpdateMetadataSchemaProperty {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		propertyFromJsonSchema: !exists(json, 'propertyFromJsonSchema')
			? undefined
			: PropertyFromJsonSchemaFromJSON(json['propertyFromJsonSchema']),
		propertyFromUISchema: !exists(json, 'propertyFromUISchema')
			? undefined
			: PropertyFromUISchemaFromJSON(json['propertyFromUISchema']),
	};
}

export function UpdateMetadataSchemaPropertyToJSON(
	value?: UpdateMetadataSchemaProperty | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		propertyFromJsonSchema: PropertyFromJsonSchemaToJSON(value.propertyFromJsonSchema),
		propertyFromUISchema: PropertyFromUISchemaToJSON(value.propertyFromUISchema),
	};
}
